const characters = [
    "ScarWizard",      // Harry Potter
    "BrainyMage",     // Hermione Granger
    "TimeLord",       // Doctor Who
    "SpaceRanger",    // Buzz Lightyear
    "TinyYoda",       // Yoda
    "WebHero",        // Spider-Man
    "IronBrain",      // Iron Man
    "NightBat",       // Batman
    "SteelDude",      // Superman
    "ChaosClown",     // Joker
    "SleuthPro",      // Sherlock Holmes
    "RingDude",       // Frodo Baggins
    "GreyWizard",     // Gandalf
    "NorthKing",      // Jon Snow
    "SnowBlade",      // Arya Stark
    "DragonMom",      // Daenerys Targaryen
    "SmartImp",       // Tyrion Lannister
    "IceQueen",       // Elsa
    "SwampGuy",       // Shrek
    "JumpMan",        // Mario
    "SparkMouse",     // Pikachu
    "GhostHunter",    // Ghostbusters
    "StarKid",        // (generic / no direct IP)
    "RumCaptain",     // Captain Jack Sparrow
    "RelicHunter",    // Indiana Jones
    "RegenGuy",       // Deadpool
    "ClawDude",       // Wolverine
    "NightRogue",     // (generic)
    "SpeedForce",     // The Flash
    "RoboPrime"       // Optimus Prime
];

const adjectives = [
    "Swift",
    "Brave",
    "Silent",
    "Fierce",
    "Clever",
    "Lucky",
    "Wild",
    "Sneaky",
    "Bold",
    "Chill",
    "Shadow",
    "Golden",
    "Stormy",
    "Mystic"
];

export { characters, adjectives };